var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C7.835 35 0 27.165 0 17.5C0 7.835 7.835 0 17.5 0C27.165 0 35 7.835 35 17.5C35 27.165 27.165 35 17.5 35Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1871 13.6008H9.56384V25.2982H13.1871V13.6008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.357 12.065C12.5433 12.065 13.4997 11.0995 13.4997 9.90398C13.4997 8.7085 12.5433 7.74292 11.357 7.74292C10.1707 7.74292 9.21436 8.7085 9.21436 9.90398C9.21436 11.0995 10.1707 12.065 11.357 12.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9805 19.1551C18.9805 17.5091 19.7346 16.5343 21.1875 16.5343C22.5209 16.5343 23.1555 17.4723 23.1555 19.1551V25.2981H26.7603V17.8861C26.7603 14.7503 24.9855 13.2329 22.5026 13.2329C20.0196 13.2329 18.9805 15.1641 18.9805 15.1641V13.5916H15.5044V25.2889H18.9805V19.1459V19.1551Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLk);
export default __webpack_public_path__ + "static/media/lk.9ffe3cf4e4029b2afdb2ff0b9dd52b15.svg";
export { ForwardRef as ReactComponent };